// Generated file - do not change manually!

/**
 * Different types of Priority.
 */
export enum Priority {
  /**
   * High priority.
   */
  High = 'High',

  /**
   * Low priority.
   */
  Low = 'Low',

  /**
   * Medium priority.
   */
  Medium = 'Medium',

  /**
   * Default, none priority.
   */
  None = 'None'
}
